"use strict";
/**
 * @author Meiblorn (Vadim Fedorenko) <meiblorn@gmail.com | admin@meiblorn.com> on 11/05/16.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var MnFullpageService = (function () {
    function MnFullpageService() {
    }
    //noinspection JSMethodCanBeStatic
    /**
     * Scrolls one section up
     */
    MnFullpageService.prototype.moveSectionUp = function () {
        $.fn.fullpage.moveSectionUp();
    };
    //noinspection JSMethodCanBeStatic
    /**
     * Scrolls one section down
     */
    MnFullpageService.prototype.moveSectionDown = function () {
        $.fn.fullpage.moveSectionDown();
    };
    //noinspection JSMethodCanBeStatic
    /**
     * Scrolls the page to the given section and slide.
     * The first slide, the visible one by default, will have index 0.
     *
     * @param section
     * @param slide
     */
    MnFullpageService.prototype.moveTo = function (section, slide) {
        $.fn.fullpage.moveTo(section, slide);
    };
    //noinspection JSMethodCanBeStatic
    /**
     * Exactly the same as moveTo but in this case it performs the scroll without animation.
     * A direct jump to the destination.
     *
     * @param section
     * @param slide
     */
    MnFullpageService.prototype.silentMoveTo = function (section, slide) {
        $.fn.fullpage.silentMoveTo(section, slide);
    };
    //noinspection JSMethodCanBeStatic
    /**
     * Scrolls the horizontal slider of the current section to the next slide
     */
    MnFullpageService.prototype.moveSlideRight = function () {
        $.fn.fullpage.moveSlideRight();
    };
    //noinspection JSMethodCanBeStatic
    /**
     * Scrolls the horizontal slider of the current section to the previous slide
     */
    MnFullpageService.prototype.moveSlideLeft = function () {
        $.fn.fullpage.moveSlideLeft();
    };
    //noinspection JSMethodCanBeStatic
    /**
     * Sets the scrolling configuration in real time.
     * Defines the way the page scrolling behaves. If it is set to true,
     * it will use the "automatic" scrolling, otherwise, it will use the "manual"
     * or "normal" scrolling of the site. Be careful when combining this option with
     * scrollOverflow set to true, as it might be difficult to scroll using the mouse
     * wheel or the trackpad when the section is scrollable
     *
     * @param enable
     */
    MnFullpageService.prototype.setAutoScrolling = function (enable) {
        $.fn.fullpage.setAutoScrolling(enable);
    };
    //noinspection JSMethodCanBeStatic
    /**
     * Sets the value for the option fitToSection determining whether to fit
     * the section in the screen or not.
     *
     * @param enable
     */
    MnFullpageService.prototype.setFitToSection = function (enable) {
        $.fn.fullpage.setFitToSection(enable);
    };
    //noinspection JSMethodCanBeStatic
    /**
     * Sets the value for the option lockAnchors determining whether
     * anchors will have any effect in the URL or not.
     *
     * @param enable
     */
    MnFullpageService.prototype.setLockAnchors = function (enable) {
        $.fn.fullpage.setLockAnchors(enable);
    };
    //noinspection JSMethodCanBeStatic
    /**
     * Adds or remove the possibility of scrolling through sections by
     * using the mouse wheel/trackpad or touch gestures (which is active
     * by default). Note this won't disable the keyboard scrolling.
     * You would need to use setKeyboardScrolling for it.
     *
     * Directions: (optional parameter) Admitted values: all, up, down,
     * left, right or a combination of them separated by commas like down,
     * right. It defines the direction for which the scrolling will
     * be enabled or disabled.
     *
     * @param allow
     * @param directions
     */
    MnFullpageService.prototype.setAllowScrolling = function (allow, directions) {
        $.fn.fullpage.setAllowScrolling(allow, directions);
    };
    //noinspection JSMethodCanBeStatic
    /**
     * Adds or remove the possibility of scrolling through sections by
     * using the keyboard arrow keys (which is active by default).
     *
     * Directions: (optional parameter) Admitted values: all, up, down,
     * left, right or a combination of them separated by commas like down,
     * right. It defines the direction for which the scrolling will be
     * enabled or disabled.
     *
     * @param allow
     * @param directions
     */
    MnFullpageService.prototype.setKeyboardScrolling = function (allow, directions) {
        $.fn.fullpage.setKeyboardScrolling(allow, directions);
    };
    //noinspection JSMethodCanBeStatic
    /**
     * Defines whether to record the history for each hash change in the URL
     *
     * @param enable
     */
    MnFullpageService.prototype.setRecordHistory = function (enable) {
        $.fn.fullpage.setRecordHistory(enable);
    };
    //noinspection JSMethodCanBeStatic
    /**
     * Defines the scrolling speed in milliseconds
     *
     * @param milliseconds
     */
    MnFullpageService.prototype.setScrollingSpeed = function (milliseconds) {
        $.fn.fullpage.setScrollingSpeed(milliseconds);
    };
    //noinspection JSMethodCanBeStatic
    /**
     * Destroys the plugin events and optionally its HTML markup and styles.
     * Ideal to use when using AJAX to load content.
     *
     * type: can be empty or all. If all is passed, the HTML markup and styles
     * used by fullpage.js will be removed. This way the original HTML markup,
     * the one used before any plugin modification is made, will be maintained.
     *
     * @param type
     */
    MnFullpageService.prototype.destroy = function (type) {
        $.fn.fullpage.destroy(type);
    };
    //noinspection JSMethodCanBeStatic
    /**
     * Updates the DOM structure to fit the new window size or its contents.
     * Ideal to use in combination with AJAX calls or external changes in the
     * DOM structure of the site.
     */
    MnFullpageService.prototype.reBuild = function () {
        $.fn.fullpage.reBuild();
    };
    return MnFullpageService;
}());
MnFullpageService.decorators = [
    { type: core_1.Injectable },
];
/** @nocollapse */
MnFullpageService.ctorParameters = function () { return []; };
exports.MnFullpageService = MnFullpageService;
//# sourceMappingURL=mnFullpage.service.js.map


//////////////////
// WEBPACK FOOTER
// C:/Front-end/[PROYECTO] abordo-empresarial-cli4/[RAMA] actualizarAngular-Analytics/abordo-empresarial-cli4/~/ngx-fullpage/components/fullpage/mnFullpage.service.js
// module id = ../../../../ngx-fullpage/components/fullpage/mnFullpage.service.js
// module chunks = 4